/* eslint-disable @khan/frontend/require-stories -- TODO */
import * as React from "react";

// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import type {PropsFor} from "@khanacademy/wonder-blocks-core";

import {PerseusI18nProviderWrapper} from "./perseus-i18n-provider-wrapper.tsx";

export const ServerItemRenderer = React.forwardRef<
    // NOTE(john): Tried to use `Perseus.ServerItemRenderer` directly, but
    // it was causing a type error. This is a workaround.
    any,
    PropsFor<typeof Perseus.ServerItemRenderer>
>((props: PropsFor<typeof Perseus.ServerItemRenderer>, ref) => (
    <PerseusI18nProviderWrapper>
        <Perseus.ServerItemRenderer {...props} ref={ref} />
    </PerseusI18nProviderWrapper>
));
